import { render, staticRenderFns } from "./datasetcausemodal.vue?vue&type=template&id=182606f4&scoped=true"
import script from "./datasetcausemodal.vue?vue&type=script&lang=js"
export * from "./datasetcausemodal.vue?vue&type=script&lang=js"
import style0 from "./datasetcausemodal.vue?vue&type=style&index=0&id=182606f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182606f4",
  null
  
)

export default component.exports